module.exports = __webpack_public_path__ + "img/img_i_coun_01.60bd6896.png";